export const IMAGES = {
  logo: "https://static.prod-images.emergentagent.com/jobs/4b4497b3-fc74-4b19-99ab-f1b62eb77cb3/images/bd41f59bcf380f258b63e12aed44bd345751bb5af473b9eb62fa33b48ce93da1.jpeg",
  tech: {
    hero: "https://images.unsplash.com/photo-1561233835-f937539b95b9?crop=entropy&cs=srgb&fm=jpg&q=85",
    security: "https://images.unsplash.com/photo-1683322499436-f4383dd59f5a?crop=entropy&cs=srgb&fm=jpg&q=85",
    cloud: "https://images.unsplash.com/photo-1695668548342-c0c1ad479aee?crop=entropy&cs=srgb&fm=jpg&q=85",
    network: "https://images.unsplash.com/photo-1639322537228-f710d846310a?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  scuba: {
    hero: "https://images.pexels.com/photos/35175952/pexels-photo-35175952.jpeg",
    diverReef: "https://images.unsplash.com/photo-1657952097610-c684335e9957?crop=entropy&cs=srgb&fm=jpg&q=85",
    diverSchool: "https://images.unsplash.com/photo-1778097931487-e26d5cd076d2?crop=entropy&cs=srgb&fm=jpg&q=85",
    diver2: "https://images.pexels.com/photos/73759/sea-ocean-water-light-73759.jpeg",
    diver3: "https://images.unsplash.com/photo-1616690571998-85f9c9d89a81",
    coral1: "https://images.unsplash.com/photo-1514907283155-ea5f4094c70c?crop=entropy&cs=srgb&fm=jpg&q=85",
    coral2: "https://images.unsplash.com/photo-1583212292454-1fe6229603b7?crop=entropy&cs=srgb&fm=jpg&q=85",
    coral3: "https://images.unsplash.com/photo-1708649290066-5f617003b93f?crop=entropy&cs=srgb&fm=jpg&q=85",
    gear: "https://images.unsplash.com/photo-1592859632074-cf5cfb714552",
    goggles: "https://images.unsplash.com/photo-1580128789542-d484253e94a3",
  },
};
